// src/features/variant_workflow/validation_schemas/silico_tool_add_validation_schema.ts
import * as Yup from 'yup';

export const silicoToolAddValidationSchema = Yup.object().shape({
  predictiontool_id: Yup.number().required('Prediction tool is required'),
  score: Yup.string()
    .nullable()
    .test(
      'is-valid-score-format',
      'Score must be a valid number (e.g. 0.87, 3.063, 101)',
      (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        const trimmed = value.trim();
        return !isNaN(Number(trimmed)) && trimmed !== '';
      },
    ),
  prediction_result: Yup.string().nullable(),
  // akzeptiere EditorState (oder string) -> mixed erlaubt beide
  comment: Yup.mixed().nullable(),
});
